import React, { useState, useEffect } from "react";
//import Text from "../../reportes/components/Text";
//import Combo from "../../reportes/components/Combo";
//import Calendar from "../../reportes/components/Calendar";
//import CmdButton from "../../reportes/components/CmdButton";
import CurrentDate from "../../reportes/helpers/CurrentDateGenerator";
import { fetchApi } from "../../tools";
import {
  MagnifyingGlassIcon,
  PencilSquareIcon,
} from "@heroicons/react/20/solid";

const classNames = (...classes) => {
  return classes.filter(Boolean).join(" ")
}

const FormBoletas = ({
  row=true,
  centro=0,
  url,
  headers,
  setData = ()=>{},
  buscarBoleta = () =>{},
  handleFormChange=()=>{},
  datosBoleta=[],
  formDisabled=false,
  saldo=0,
  habilitarFormBoleta = () =>{},
}) => {

  //const [controlesBloqueados]
  const [bancos, setBancos] = useState([]);
  const getBancos = async () => {
    const resBancos = await fetchApi({
      url: url + "/utils/busquedas",
      headers,
      content: { opcion: "BANCOS" },
    });
    //console.log("BANCOS: ", resBancos);
    setBancos(() => resBancos);
  };

  useEffect(() => {
    setData({
      ...datosBoleta,
      saldo:0,
      valor:0,
      fecha: CurrentDate(),
    });
    getBancos();
    habilitarFormBoleta()
  }, []);

  return (
    <>
      <div className={classNames(centro?"":"m-6 p-2","flex flex-col bg-secundarioMira w-full rounded-md")}>
        
        <div className={"flex flex-col  p-1 rounded-md gap-1 shadow-sm shadow-white"}>
            <h1 className={"text-white mb-4 font-medium"}>Búsqueda de boleta</h1>
        <div className={classNames(row ? "flex-row":"flex-col", "flex p-1 rounded-md gap-1 ")}>

          <div className={"flex flex-col"}>
            <label className="text-white">Número de boleta</label>
            <input
              type="number"
              name="boleta"
              disabled={formDisabled}
              onChange={(e) => handleFormChange(e)}
              className={"rounded-md w-full text-black basis-1/4 m-auto"}
              />
          </div>

          <div className={"flex flex-col"}>
            <label className="text-white">Banco</label>
            <select
              name="banco"
              type="select"
              disabled={formDisabled}
              onChange={(e) => handleFormChange(e)}
              className={"rounded-md w-full text-black basis-1/4 m-auto"}
              >
              <option value="">{"---Selecciona el Banco---"}</option>
              {bancos.map((data) => (
                <option key={data.IdBanco} value={data.IdBanco}>
                  {data.Nombre}
                </option>
              ))}
            </select>
          </div>

          <div className={"flex flex-col"}>
            <label className="text-white">Fecha</label>
            <input
              name={"fecha"}
              type="date"
              min="1900-01-01"
              max="2099-01-01"
              disabled={formDisabled}
              onChange={(e) => handleFormChange(e)}
              value={datosBoleta.fecha}
              className={"rounded-md w-full text-black basis-1/4 m-auto p-5"}
              ></input>
          </div>

          <div className={"basis-1/4 m-auto mt-6"}>
            <button
              disabled={formDisabled}
              type="button"
              className={`bg-azulBrillanteMira secundario rounded-md hover:shadow-white ${formDisabled?"":"shadow-sm"}  text-white p-2 center w-full flex flex-row hover:${formDisabled?"selection":"pointer"} mt-3`}
              onClick={() => buscarBoleta("buscar boleta")}
              >
              <div className={" float-right m-auto flex flex-row"}>
                <MagnifyingGlassIcon className={"h-6 w-6"} />
                <span className={"ml-2 m-auto"}>{"Buscar"}</span>
              </div>
            </button>
          </div>
        </div>
        </div>
        
          <div className={"flex flex-row"}>
            <div className={"w-full flex-row "}>
              <div className={"flex flex-row shadow-sm shadow-white p-1 rounded-md mt-2"}>
                <p
                  className={"  font-medium text-secundario m-auto"}
                  >{`Saldo de boleta: Q ${saldo | 0 }`}</p>
              </div>
            </div>
          </div>
        

        {/*
        <div className={"flex flex-col bg-secundarioMira p-4 rounded-md"}>
        <h1 className={"text-white mb-4 font-medium"}>Monto a Pagar</h1>
        <Text label={"Monto"}/>
        <Text label={"Saldo"}/>
        <CmdButton 
            title={"Registrar boleta"}
            children={<PencilSquareIcon className={"h-6 w-6"}/>}
        />
        </div>
        */}
      </div>
    </>
  );
};

export default FormBoletas;
